import { Grid, Box, Typography, makeStyles, Chip } from "@material-ui/core";
import { StatusType, Tabs } from "@roc/ui";
import { PropertiesSummary, EditPropertyFlood, OverrideFloodZone } from "./propertyDetails";
import { InsuranceInformationReviewForm, InsuranceInformationReviewFormProps } from "./insuranceInformationReviewForm";
import { useState } from "react";
import { observer } from 'mobx-react';
import { StatusChip } from "@roc/ui";
import { useStore } from "@roc/client-portal-shared/hooks";
import { InsuranceQuoteStatusChip } from "libs/feature-borrower-review/src/components/InsuranceQuoteStatusChip";

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: 'white',
    display: 'block'
  },
  title: {
    margin: '0 0 20px 0',
    display: 'flex',
    alignItems: 'center'
  },
  tabs: {
    border: 'none !important'
  }
}));

export const renderContentPropertyDetailsContent = (state, setState) => {
  if (state.uploadFloodCert) return <EditPropertyFlood
    setUploadMode={(value) => setState(prev => ({ ...prev, uploadFloodCert: value }))} />
  if (state.override) return <OverrideFloodZone
    setOverrideMode={(value) => setState(prev => ({ ...prev, override: value }))} />
}

export const InsuranceInformationReview = observer(({ showTitle = true, ...props }: InsuranceInformationReviewFormProps) => {
  const [state, setState] = useState({
    tab: 0,
    uploadFloodCert: false,
    override: false
  });
  const classes = useStyles();
  const { insuranceInformationReviewStore } = useStore();

  const renderContent = () => {

    if (state.uploadFloodCert || state.override) {
      return renderContentPropertyDetailsContent(state, setState);
    }

    switch (state.tab) {
      case 0: return <InsuranceInformationReviewForm {...props} />;
      case 1: return <PropertiesSummary
        setUploadMode={(value) => setState(prev => ({ ...prev, uploadFloodCert: value }))}
        setOverrideMode={(value) => setState(prev => ({ ...prev, override: value }))} />;
    }
  }

  return (
    <Grid container className={classes.container}>
      {(showTitle || insuranceInformationReviewStore.insuranceAutomationStatus) &&
        <Grid item xs={12} container spacing={1} className={classes.title}>
          {showTitle && <Grid item>
            <Typography variant="h4">{state.tab == 0 ? 'Insurance Information Review' : 'Property Review'}</Typography>
          </Grid>
          }
          {insuranceInformationReviewStore.insuranceAutomationStatus && <Grid item>
            <InsuranceQuoteStatusChip properties={{ label: insuranceInformationReviewStore.automationStatusMappingValue, status: insuranceInformationReviewStore.insuranceAutomationStatus }} />
          </Grid>}
        </Grid>
      }
      {!(state.uploadFloodCert || state.override) && <Grid item xs={12}>
        <Tabs
          tabs={[{ label: 'Insurance Review' }, { label: 'Property Details' }]}
          selectedTab={state.tab}
          onTabChange={(e, index) => setState(prev => ({ ...prev, tab: index }))}
          className={classes.tabs}
        />
      </Grid>}
      <Grid item xs={12}>
        {renderContent()}
      </Grid>
    </Grid>
  );
});